import config from '../../config';
import APIService from './APIService';

export default class CommentService extends APIService {
  /**
   * To add a comment in Attachment, Email or Document
   * 
   * @param {string} projectId
   * @param {Object} postBody
   * 
   * The post body example- {
        archiveId: this.archiveId,
        comment: this.commentDesc,
        endIndex: this.objSelection.endOffset,
        endPoint: this.objSelection.endXPath,
        isResolved: 0,
        achiveType: 'EMAIL',
        attachmentId: 0,
        startIndex: this.objSelection.startOffset,
        startPoint: this.objSelection.startXPath,
        userId: localStorage.getItem('loggedInUserId')
      };

      A comment can be added from EmailViewer.vue and RenderAttachment.vue
      Some variables are used differently for different cases
   */
  static addComment(projectId, postBody) {
    return this.post(
      `${config.baseUrlForAnnotations}/comments/${projectId}`,
      postBody
    );
  }

  /**
   * To delete a comment
   * @param {string} commentId
   */
  static deleteComment(commentId) {
    let url = `${config.baseUrlForAnnotations}/comments/${commentId}`;
    return this.delete(url);
  }

  /**
   * To delete a tag
   * @param {string} commentId
   */
  static deleteTag(commentId) {
    let url = `${config.baseUrlForAnnotations}/tags/${commentId}`;
    return this.delete(url);
  }

  /**
   * To add a in Attachment, Email or Document
   * @param {string} projectId
   * @param {string} postBody
   *  
   * Example Tag body = {
        archiveId: this.archiveId,
        tag: this.tagText.toLowerCase(),
        endIndex: this.objSelection.endOffset,
        endPoint: this.objSelection.endXPath,
        achiveType: 'EMAIL',
        attachmentId: 0,
        startIndex: this.objSelection.startOffset,
        startPoint: this.objSelection.startXPath,
        userId: localStorage.getItem('loggedInUserId')
      }

   * Some variables are used differently for different cases
   */
  static addTag(projectId, postBody) {
    return this.post(
      `${config.baseUrlForAnnotations}/tags/${projectId}`,
      postBody
    );
  }

  /**
   * To load comments and tags for a email, attachment or document
   *
   * @param {string} projectId
   * @param {string} archiveId
   * @param {number} attachmentId
   */
  static loadCommentsForArchive(projectId, archiveId, attachmentId) {
    let postBody = {
      archiveId: archiveId,
      attachmentId: attachmentId || 0
    };
    return this.post(
      `${config.baseUrlForAnnotations}/project/${projectId}`,
      postBody
    );
  }

  /**
   * To add a reply to the comment
   *
   * @param {string} commentId
   * @param {string} commentDesc
   */
  static addCommentReply(commentId, commentDesc) {
    return this.put(`${config.baseUrlForAnnotations}/comments/reply`, {
      comment: commentDesc,
      commentId,
    });
  }

  /**
   * To edit the comment
   *
   * @param {string} commentId
   * @param {string} commentDesc
   */
  static editCommentReply(commentId, commentDesc) {
    return this.patch(`${config.baseUrlForAnnotations}/comments/reply`, {
      comment: commentDesc,
      commentId,
    });
  }

  /**
   * To get all the comments associated to a commentId
   * @param {string} commentId
   */
  static getCommentReplies(commentId) {
    return this.get(`${config.baseUrlForAnnotations}/comments/${commentId}`);
  }

  /**
   * To resolve a comment
   * @param {string} commentId
   */
  static resolveComment(commentId) {
    return this.patch(
      `${config.baseUrlForAnnotations}/comments/${commentId}/resolved`
    );
  }
}
